export const downloads = {
  seo: {
    title: 'Downloads | Bistroo',
    description: 'Download the Bistroo Manager app for iOS and Android. Manage your restaurant easily from your smartphone.',
  },
  title: 'Downloads',
  subtext: 'On this page you will find an overview of all Bistroo Manager versions',
  operating_system: {
    win: 'Windows',
    mac_os: 'Mac OSX',
  },
  supported_subversions: {
    win: 'Windows 7, Windows 8, Windows 10, Windows 11',
    mac_os: 'Ventura, Monterey, Big Sur',
  },

  btn_text: 'Download',

  latest_version_text:
    'Download the latest version of Bistroo Manager for {os}. At this moment, this is version {version}',

  previous_versions_title: 'Previous versions',
  previous_versions_subtext:
    'On this page you will find an overview of all Bistroo Manager versions',
}
